import { render } from "./CancerReserve.vue?vue&type=template&id=0e4d139f"
import script from "./CancerReserve.vue?vue&type=script&lang=js"
export * from "./CancerReserve.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__